<div id="forms" class="page-layout simple fullwidth" fxLayout="column" (window:resize)="onResize($event)">
    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
            <button mat-icon-button class="mr-16" (click)="regresarDetail()">
                    <mat-icon>arrow_back</mat-icon>
            </button>
              <h1 class="m-0">{{'PERFILES.EMPRESA.TITUHEAD' | translate}}</h1>
        </div>

       <div class="content-card p-20">
        <mat-sidenav-container class="example-container">
        <mat-sidenav #sidenav mode="side" opened="{{menu}}" class="example-sidenav" >
          <div class="menu">
            <h2 class="titulo">{{'PERFILES.EMPRESA.ACTUALIZAR_BD.TITULO' | translate }}</h2>
            <div fxLayout="row" fxLayoutAlign="start center">
            <mat-icon id="icon">person</mat-icon>&nbsp;&nbsp;&nbsp;&nbsp;
            <p>{{'PERFILES.EMPRESA.ACTUALIZAR_BD.INSTRUCCIONES.INSTRUCCION_1' | translate }}</p>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center">
            <mat-icon id="icon">cloud_download</mat-icon>&nbsp;&nbsp;&nbsp;&nbsp;
            <p>{{'PERFILES.EMPRESA.ACTUALIZAR_BD.INSTRUCCIONES.INSTRUCCION_2' | translate }}</p>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center">
            <mat-icon id="icon">update</mat-icon>&nbsp;&nbsp;&nbsp;&nbsp;
            <p>{{'PERFILES.EMPRESA.ACTUALIZAR_BD.INSTRUCCIONES.INSTRUCCION_3' | translate }}</p>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center">
            <mat-icon id="icon">delete</mat-icon>&nbsp;&nbsp;&nbsp;&nbsp;
            <p>{{'PERFILES.EMPRESA.ACTUALIZAR_BD.INSTRUCCIONES.INSTRUCCION_4' | translate }}</p>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center">
            <mat-icon id="icon">cloud_upload</mat-icon>&nbsp;&nbsp;&nbsp;&nbsp;
            <p>{{'PERFILES.EMPRESA.ACTUALIZAR_BD.INSTRUCCIONES.INSTRUCCION_5' | translate }}</p>
            </div>
          </div>
        </mat-sidenav>

        <mat-sidenav-content class="Sinedav_two">
          <p *ngIf="boton==true"><button mat-button (click)="sidenav.toggle()">
          <mat-icon>menu</mat-icon>
          </button></p>

          <div fxLayout class="stepper">
          <mat-horizontal-stepper fxFlex="100">
           <mat-step label="Descargar BD colaboradores" state="person">
             <app-bd-colaboradores
             [empresaId]="idEmpresa"
             [productoID]="idProducto"
             [fechaProducto]="fechaprod">
             </app-bd-colaboradores>
             <!-- <div fxLayout="row" fxLayoutAlign="center end">
               <button mat-button matStepperNext>Next</button>
             </div> -->
           </mat-step>
           <mat-step label="Descargar plantilla" state="cloud_download">
             <app-descargar-plantilla
             [empresaId]="idEmpresa"
             [productoID]="idProducto"
             [fechaProducto]="fechaprod">
             </app-descargar-plantilla>
             <!-- <div>
               <button mat-button matStepperPrevious>Back</button>
               <button mat-button matStepperNext>Next</button>
             </div> -->
           </mat-step>
           <mat-step label="Subir BD actualizada" state="cloud_upload">
             <p>You're welcome.</p>
           </mat-step>

          </mat-horizontal-stepper>
          </div>

        </mat-sidenav-content>
        </mat-sidenav-container>
        </div>
    </div>
</div>
